import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const resolveUrl = (u, w) => {
  if (!u) return "";
  if (u.startsWith("http")) return u; // external CDN images are already sized
  const base = `${BACKEND_URL}${u}`;
  if (w) return `${base}${base.includes("?") ? "&" : "?"}w=${w}`;
  return base;
};

// Build a responsive srcset for backend-hosted images. Returns undefined for
// external/default images (they're already sized) so React omits the attribute.
export const buildSrcSet = (u, widths) => {
  if (!u || u.startsWith("http")) return undefined;
  return widths
    .map((w) => `${BACKEND_URL}${u}${u.includes("?") ? "&" : "?"}w=${w} ${w}w`)
    .join(", ");
};

export const getToken = () => localStorage.getItem("cs_admin_token");
export const setToken = (t) => localStorage.setItem("cs_admin_token", t);
export const clearToken = () => localStorage.removeItem("cs_admin_token");

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export async function uploadImage(file, square = false) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/upload?square=${square}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

// Push a GTM/dataLayer event (works even before GTM loads; GTM replays the queue).
export function pushEvent(event, data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}
